module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.hourRegistrationStarted) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.startHourRegistration
    }
  }, [_vm._v("Start urenregistratie")]) : _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stopHourRegistartion
    }
  }, [_vm._v("Stop urenregistratie")]), _vm._v(" "), _c('hour-registration-table', {
    ref: "registrationTable",
    attrs: {
      "userId": this.$auth.getUser().id,
      "role": "orderpicker"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-basket mr-5"
  }), _vm._v(" Uren registratie\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cba27f00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/employees/HourRegistrationPage.vue
// module id = 758
// module chunks = 1